// extracted by mini-css-extract-plugin
export default {"content":"content--HxEQ_","fab":"fab--WWGBG"};